<div *ngIf="isReady">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree-selector-tree">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20"
                   attr.data-cy="{{node.name}}">
      <!-- use a disabled button to provide padding for tree leaf -->
      <button class="expend-collapse-btn" disabled mat-icon-button></button>
      <!--      <img-->
      <!--        src="{{node.icon}}"/>-->

      <button matTooltip="{{node.name}}" (click)="onTreeNodeClicked($event, node)"
              class="drive-tree-view-node-name flex flex-row justify-start items-center">
        <div class="{{node.icon}}"></div>
        {{node.name}}
      </button>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" attr.data-cy="{{node.name}}"
                   [ngClass]="{'highlight-node':  highlightedNode?.itemId === node?.itemId}"
                   matTreeNodePadding
                   matTreeNodePaddingIndent="20">
      <div class="expand-enabled-button">
        <button [attr.aria-label]="'Toggle ' + node.name"
                *ngIf="node.childrenLength > 0"
                mat-icon-button
                matTreeNodeToggle>
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
      </div>
      <!--      <img src="{{node.icon}}"/>-->
      <div class="{{node.icon}}"></div>
      <button matTooltip="{{node.name}}" (click)="onTreeNodeClicked($event, node)" class="drive-tree-view-node-name">
        {{node.name}}
      </button>
    </mat-tree-node>
  </mat-tree>
</div>
